<template>
  <div
    @click.stop="toProductDetail"
    class="full-width"
    :class="{
      'cursor-pointer':
        !rewardsFormat ||
        (this.cartProduct.redeemable && $vuetify.breakpoint.xsOnly),
    }"
    :data-upc="product.upc"
  >
    <div v-if="warn" @click.stop="warn = !warn" :class="classes.height">
      <AlcoholWarning v-if="product.is_alcohol" :xs="size === 'xs'" />
      <TobaccoWarning v-if="product.is_tobacco" :xs="size === 'xs'" />
      <div class="d-flex justify-center mt-8">
        <a>
          <v-icon color="primary">mdi-chevron-down</v-icon>
        </a>
      </div>
    </div>
    <div
      v-else
      class="d-flex e2e-product-upc flex-column justify-space-around overflow-hidden position-relative"
      :class="
        size === 'xs' && rewardsFormat && !product.redeemable
          ? 'height-xs-rewards-format'
          : classes.height
      "
    >
      <div class="align-center d-flex justify-space-between">
        <FavoriteIcon
          v-if="size !== 'sm' && !product.loyalty"
          :mobile="size === 'xs'"
          :upc="product.upc"
        />
        <CornerRibbon
          v-if="
            ((product.pricebook_info.promotions &&
              product.pricebook_info.promotions.length) ||
              product.new_product) &&
            !product.loyalty
          "
          :newItem="
            !(
              product.pricebook_info.promotions &&
              product.pricebook_info.promotions.length
            )
          "
          :large="$vuetify.breakpoint.smAndUp"
        />
      </div>
      <div class="align-center d-flex flex-column">
        <img
          v-if="product.image"
          :alt="product.name"
          :src="product.image"
          :class="classes.imageSize"
          loading="lazy"
          style="mix-blend-mode: multiply"
        />
        <NoImageAvailable
          v-else
          :departmentName="
            getProductDepartmentName(
              product.parent_categories,
              product.categories,
            )
          "
          :size="size"
        />
        <div class="align-center d-flex flex-column py-3">
          <div
            :class="classes.descriptionHeight"
            class="d-flex flex-column justify-space-between overflow-hidden"
          >
            <div>
              <UnitPriceDisplay
                :byweight="product.byweight"
                :type="'generic'"
                :unitPrice="product.cents"
                :loyalty="product.loyalty"
                :redeemable="product.redeemable || rewardsFormat"
                :points="product.redemption_points_offer"
              />
              <div
                v-line-clamp="2"
                class="color-dim-gray font-size-md-res word-break-normal e2e-product-name"
              >
                {{ removeLongWordsFromProductName(product.name) }}
              </div>

              <UnitSizeDisplay
                :baseSize="product.base_size"
                :size="product.size"
                :type="'generic'"
                :small="$vuetify.breakpoint.xsOnly"
                :uom="product.uom"
              />
            </div>
            <div class="d-flex justify-center">
              <TermsSingle
                v-if="!product.loyalty"
                :byweight="product.byweight"
                :promotions="product.pricebook_info.promotions"
                :small="size === 'xs'"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          !rewardsFormat || (product.redeemable && $vuetify.breakpoint.xsOnly)
        "
      >
        <div
          class="align-center d-flex flex-column"
          v-if="$vuetify.breakpoint.xsOnly && product.redeemable"
        >
          <v-btn color="primary" :height="44" :width="118" rounded>
            <span
              class="px-5 font-size-sm font-weight-bold text-none text-center"
              >Redeem</span
            >
          </v-btn>
        </div>
        <div class="align-center d-flex flex-column" v-else>
          <TobaccoButton
            v-if="product.is_tobacco && notCategoryPage"
            :small="size === 'xs'"
            :loyalty="product.loyalty"
            :redeemable="product.redeemable"
            :points="product.redemption_points_offer"
          />
          <CartQuantityButton
            v-else
            :cartProduct="cartProduct"
            :quantityType="'cartQty'"
            :small="size === 'xs'"
          />
          <span
            :class="
              product.is_tobacco || product.is_alcohol ? 'visible' : 'hidden'
            "
            class="font-size-xs-res mt-1 px-1 text-center"
            @click.stop="warn = !warn"
          >
            California Residents:
            <a class="e2e-californiawarning-link"
              >Click here for Proposition 65 WARNING</a
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getProductDepartmentName,
  getProductDetailViewFromProductState,
  removeLongWordsFromProductName,
} from "@/util.js";
import { mapGetters } from "vuex";
import AlcoholWarning from "@/components/Product/AlcoholWarning.vue";
import CartQuantityButton from "@/components/Product/CartQuantityButton.vue";
import FavoriteIcon from "@/components/Product/FavoriteIcon.vue";
import NoImageAvailable from "@/components/Product/NoImageAvailable.vue";
import CornerRibbon from "@/components/Product/Promotions/CornerRibbon.vue";
import TermsSingle from "@/components/Product/Promotions/Terms/Single.vue";
import TobaccoButton from "@/components/Product/TobaccoButton.vue";
import TobaccoWarning from "@/components/Product/TobaccoWarning.vue";
import UnitPriceDisplay from "@/components/Product/UnitPriceDisplay.vue";
import UnitSizeDisplay from "@/components/Product/UnitSizeDisplay.vue";

const classes = {
  xs: {
    descriptionHeight: "fixed-height-xs",
    height: "height-xs",
    imageSize: "product-image-size-xs",
  },
  sm: {
    descriptionHeight: "fixed-height-sm",
    height: "height-sm",
    imageSize: "product-image-size-sm",
  },
  md: {
    descriptionHeight: "fixed-height-md",
    height: "height-md",
    imageSize: "product-image-size",
  },
};

export default {
  name: "Product",
  components: {
    AlcoholWarning,
    CartQuantityButton,
    FavoriteIcon,
    NoImageAvailable,
    CornerRibbon,
    TermsSingle,
    TobaccoButton,
    TobaccoWarning,
    UnitPriceDisplay,
    UnitSizeDisplay,
  },
  computed: {
    ...mapGetters({
      getProductItemsAndQuantityInCart: "cart/getProductItemsAndQuantityInCart",
    }),
    ...mapGetters("store", { rewardsFormat: "rewardsFormat" }),
    cartProduct() {
      const itemsAndQuantityFromCart = this.getProductItemsAndQuantityInCart(
        this.product,
      );
      return {
        ...this.product,
        ...itemsAndQuantityFromCart,
      };
    },
    notCategoryPage() {
      return !this.$route.params.categoryId;
    },
  },
  data() {
    return {
      classes: classes[this.size],
      warn: false,
    };
  },
  methods: {
    getProductDepartmentName,
    removeLongWordsFromProductName,
    toProductDetail() {
      if (
        this.rewardsFormat &&
        (!this.cartProduct.redeemable || !this.$vuetify.breakpoint.xsOnly)
      )
        return;
      this.$store.dispatch(
        "product/setCurrentProductDetails",
        this.cartProduct,
      );
      const view = getProductDetailViewFromProductState(this.cartProduct);
      let routeName = this.product.redeemable ? "rewardProduct" : "product";
      this.$vuetify.breakpoint.xsOnly
        ? this.$router.push({
            name: routeName,
            params: { upc: this.cartProduct.upc_encoded, view },
            query: routeName === "rewardProduct" ? this.$route.query : {},
          })
        : this.$store.dispatch("product/openDialog", view);
    },
  },
  props: {
    product: Object,
    size: String,
  },
};
</script>

<style scoped>
.fixed-height-md {
  height: 134px;
}

.fixed-height-sm {
  height: 118px;
}

.fixed-height-xs {
  height: 110px;
}

.height-md {
  height: 444px;
}

.height-sm {
  height: 375px;
}

.height-xs {
  height: 330px;
}

.height-xs-rewards-format {
  height: 240px;
}

.word-break-normal {
  word-break: normal;
}
</style>
